import {
  Component,
  ElementRef,
  Input,
  OnChanges,
  Renderer2,
  SimpleChanges
} from '@angular/core';

@Component({
  selector: 'loading-spinner',
  templateUrl: './loading-spinner.component.html',
  styleUrls: ['./loading-spinner.component.scss']
})
export class LoadingSpinnerComponent implements OnChanges {
  @Input() public size = '30px';

  constructor(private ref: ElementRef, private renderer: Renderer2) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.size.currentValue) {
      const element = this.ref.nativeElement.querySelector(
        '.loader'
      ) as HTMLElement;
      this.renderer.setStyle(element, 'width', this.size);
      this.renderer.setStyle(element, 'height', this.size);
    }
  }
}
